import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/eye.svg'
import _imports_1 from '../../../assets/img/icons/edit.svg'
import _imports_2 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "py-4 text-center text-muted" }
const _hoisted_4 = {
  key: 2,
  class: "d-flex justify-content-center gap-2 table-actions"
}
const _hoisted_5 = ["title", "onClick"]
const _hoisted_6 = ["alt"]
const _hoisted_7 = ["title", "onClick"]
const _hoisted_8 = ["alt"]
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.suppliers,
        "row-key": 'id',
        loading: _ctx.loading,
        pagination: _ctx.tablePagination,
        scroll: { x: 1160 },
        class: "text-nowrap align-middle people-table",
        onChange: _ctx.handleTableChange
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("supplier_page.no_suppliers_found")), 1)
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column && column.key === 'date')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDate(record.created_at)), 1)
              ], 64))
            : (column && column.key === 'status')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["status-badge", Number(record.status || 0) === 1 ? 'status-active' : 'status-inactive'])
                }, _toDisplayString(Number(record.status || 0) === 1 ? _ctx.t("supplier_page.status_active") : _ctx.t("supplier_page.status_inactive")), 3))
              : (column && column.key === 'actions')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("button", {
                      class: "btn p-0 border-0 action-icon-btn",
                      title: _ctx.t('supplier_page.view'),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#supplierDetailsModal",
                      onClick: ($event: any) => (_ctx.$emit('view-supplier', record))
                    }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: _ctx.t('supplier_page.view'),
                        style: {"width":"14px"}
                      }, null, 8, _hoisted_6)
                    ], 8, _hoisted_5),
                    _createElementVNode("button", {
                      class: "btn p-0 border-0 action-icon-btn",
                      title: _ctx.t('supplier_page.edit'),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#supplierCreateModal",
                      onClick: ($event: any) => (_ctx.$emit('edit-supplier', record))
                    }, [
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: _ctx.t('supplier_page.edit'),
                        style: {"width":"14px"}
                      }, null, 8, _hoisted_8)
                    ], 8, _hoisted_7),
                    _createElementVNode("button", {
                      class: "btn p-0 border-0 action-icon-btn",
                      title: _ctx.t('supplier_page.delete'),
                      onClick: ($event: any) => (_ctx.$emit('delete-supplier', record))
                    }, [
                      _createElementVNode("img", {
                        src: _imports_2,
                        alt: _ctx.t('supplier_page.delete'),
                        style: {"width":"14px"}
                      }, null, 8, _hoisted_10)
                    ], 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination", "onChange"])
    ])
  ]))
}